var exports = {
  "k": "xcc377c0b--504048--container",
  "w": "xcc377c0b--504048--logo",
};

module.exports = exports;
